<!--  -->
<template>
  <div class="user-man">
    <div id="myChart" class="User"></div>
  </div>
</template>

<script>
export default {
  name: "user",
  data() {
    return {
      // title:'用户数量排行前二十的市级城市',
      title: ""
    };
  },
  mounted() {
    this.drawLine();
  },
  methods: {
    drawLine() {
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.title,
          left: 20,
          top: 20,
          textStyle: {
            fontSize: 22,
            fontWeight: "normal", //标题颜色
            color: "#4CB1C7"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        legend: {
          data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: {
          type: "value",
          show: false
        },
        yAxis: {
          axisLine: {
            lineStyle: {
              color: "#ffffff",
              width: 1
            }
          },
          axisTick: {
            lineStyle: {
              color: "#67EBFF"
            }
          },
          axisLine: {
            lineStyle: {
              color: "#67EBFF"
            }
          },
          type: "category",
          data: [
            "合肥",
            "马鞍山",
            "刘安",
            "驻马店",
            "桂林",
            "马鞍山",
            "刘安",
            "驻马店",
            "桂林",
            "合肥",
            "马鞍山",
            "刘安",
            "驻马店"
          ]
        },
        series: [
          {
            type: "bar",
            stack: "总量",
            label: {
              normal: {
                color: "#000000",
                show: true,
                position: "insideRight"
              }
            },
            color: "#67EEFF",
            data: [
              120,
              302,
              399,
              500,
              499,
              302,
              399,
              489,
              499,
              500,
              499,
              804,
              499
            ]
          }

          // {
          //   type: "bar",
          //   stack: "总量",
          //   label: {
          //     normal: {
          //       color: "#ffffff",
          //       show: true,
          //       position: "insideRight"
          //     }
          //   },
          //   color: "#0083D0",
          //   data: [
          //     820,
          //     500,
          //     499,
          //     500,
          //     499,
          //     302,
          //     399,
          //     222,
          //     499,
          //     500,
          //     499,
          //     200,
          //     499
          //   ],
          //   itemStyle: {
          //     //柱形图圆角，鼠标移上去效果，如果只是一个数字则说明四个参数全部设置为那么多
          //     emphasis: {
          //       barBorderRadius: 30
          //     },
          //     normal: {
          //       //柱形图圆角，初始化效果
          //       // barBorderRadius: [0, 10, 10, 0]
          //     }
          //   }
          // }
        ]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.User {
  margin: 35px 0 0 10px;
  width: 90%;
  height: 95%;
}
</style>
